import React, { Suspense } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/authcontext";
import Loader from "../components/loader/loader";
import Header from "../components/layout/header";
import Footer from "../components/layout/footer";

import SEO from "../components/SEO/SEO";
import PageTitle from "../components/SEO/PageTitle";

const PrivateRoute = () => {
  const user = useAuth();
  const location = useLocation();

  if (!user.token) {
    return <Navigate to={`/login?redirect=${location.pathname}`} replace />;
  }

  return (
    <Suspense fallback={<Loader />}>
      <PageTitle />
      <SEO />
      <Header/>
      <Outlet />
      <Footer/>
    </Suspense>
  );
};

export default PrivateRoute;
